import React from "react";
import CustomCheckbox from "../../common/CustomCheckbox";
import CustomInput from "../../common/CustomInput";
import CustomSelect from "../../common/CustomSelect";
import PhoneInput from "../../common/PhoneInput";
import { currencyCodes, isMobileView, validateEmail } from "../../../lib/utils";

export default class PersonalInfo extends React.PureComponent {
  state = {
    didAcceptNonUKTerms: false,
    didAcceptUKAdminTerms: false,
    didAcceptUKPromoterTerms: false,
  };

  toggleAcceptTerms = (event) => {
    this.setState(
      {
        [event.target.name]: event.target.checked,
      },
      () => {
        const allTermsAccepted =
          this.props.currencyCode === currencyCodes.GBP
            ? this.state.didAcceptUKAdminTerms &&
              this.state.didAcceptUKPromoterTerms
            : this.state.didAcceptNonUKTerms;
        this.props.toggleDidAcceptTerms(allTermsAccepted);
      }
    );
  };

  render() {
    const {
      associations,
      countries,
      currencyCode,
      gregorianYear,
      onChange,
      onChangeEvent,
      order: {
        association,
        address,
        email,
        firstName,
        isUkGiftAid,
        isPrivate,
        lastName,
        phone,
        referrerID,
        tribute,
      },
      orderValidationErrors,
      referrers,
      requireDonorPhone,
      submitAttempted,
      termsAndConditions,
      toggleShowTermsAndConditions,
      updateOrderValidation,
    } = this.props;

    const {
      didAcceptNonUKTerms,
      didAcceptUKAdminTerms,
      didAcceptUKPromoterTerms,
    } = this.state;

    const donateAnonymouslyCheckbox = (
      <div
        className="custom-checkbox-container flex mt-8"
        style={{ gridColumn: "span 2", height: "20px" }}
      >
        <CustomInput
          className="custom-checkbox"
          id="isPrivate"
          name="isPrivate"
          onChange={onChangeEvent}
          type="checkbox"
          value={isPrivate}
        />
        <label htmlFor="isPrivate">I would like to donate anonymously</label>
      </div>
    );

    const isMobile = isMobileView();

    return (
      <div>
        <p className="fs-28 fw-600 brand-color-text mb-32 text-center">
          Checkout
        </p>
        <div className="container">
          <p className="fs-20 fw-600 mb-32">Personal Info</p>
          <div className="checkout-grid">
            <div
              className={`flex flex-align-center mobile-block ${
                submitAttempted && !firstName ? "error" : ""
              }`}
            >
              <label>First Name</label>
              <CustomInput
                autoComplete="given-name"
                error={submitAttempted && !firstName}
                name="firstName"
                onChange={onChangeEvent}
                type="text"
                value={firstName}
              />
              {!isMobile && donateAnonymouslyCheckbox}
            </div>

            <div
              className={`flex flex-align-center mobile-block ${
                submitAttempted && !lastName ? "error" : ""
              }`}
            >
              <label>Last Name</label>
              <CustomInput
                autoComplete="family-name"
                error={submitAttempted && !lastName}
                name="lastName"
                onChange={onChangeEvent}
                type="text"
                value={lastName}
              />
              {isMobile ? (
                donateAnonymouslyCheckbox
              ) : (
                // placeholder to align the first and last name inputs for desktop
                <div className="mt-8" style={{ height: "20px" }} />
              )}
            </div>

            <div
              className={`flex flex-align-center mobile-block ${
                (submitAttempted && !email) ||
                orderValidationErrors.indexOf("email") >= 0
                  ? "error"
                  : ""
              }`}
            >
              <label>Email Address</label>
              <CustomInput
                autoComplete="email"
                error={
                  (submitAttempted && !email) ||
                  orderValidationErrors.indexOf("email") >= 0
                }
                name="email"
                onBlur={(event) => {
                  const isValidEmail =
                    !event.target.value || validateEmail(event.target.value);
                  updateOrderValidation(event.target.name, isValidEmail);
                }}
                onChange={onChangeEvent}
                type="text"
                value={email}
              />
              {orderValidationErrors.indexOf("email") >= 0 && (
                <span className="error-text">Invalid Email Address</span>
              )}
            </div>

            <div
              className={`flex flex-align-center mobile-block ${
                (requireDonorPhone && submitAttempted && !phone) ||
                orderValidationErrors.indexOf("phone") >= 0
                  ? "error"
                  : ""
              }`}
            >
              <label className="label-with-sub">
                Phone Number <span>(so we can call you if you win)</span>
              </label>
              <PhoneInput
                countries={countries}
                defaultCountryName={
                  currencyCode === currencyCodes.GBP
                    ? "United Kingdom"
                    : address.country
                }
                error={
                  (requireDonorPhone && submitAttempted && !phone) ||
                  orderValidationErrors.indexOf("phone") >= 0
                }
                name="phone"
                onChange={(phone) => {
                  onChange("phone", phone);
                }}
                validate={(isValid) => updateOrderValidation("phone", isValid)}
                value={phone}
              />
            </div>
            <div className="flex flex-align-center mobile-block">
              <label className="label-with-sub">
                Association <span>(optional)</span>
              </label>
              <CustomSelect
                clearable={true}
                name="association"
                placeholder="Select an association"
                onChange={onChange}
                options={associations.map((association) => ({
                  display: association.displayValue,
                  value: association.enumValue,
                }))}
                value={association}
              />
            </div>
            {/* empty div to keep an empty space in the grid (not needed for mobile) - CG */}
            <div className="mobile-hidden"></div>
            <div
              className="flex flex-align-center span-two mobile-block"
              style={{ gridColumn: "span 2" }}
            >
              <label className="label-with-sub">
                Tribute <span>(optional)</span>
              </label>
              <CustomInput
                name="tribute"
                onChange={onChangeEvent}
                placeholder="In memory of, etc"
                type="text"
                value={tribute}
              />
            </div>

            {!!referrers.length && (
              <div
                className="team-dropdown"
                style={{
                  gridColumn: "span 2",
                  background: "#F2F2F2",
                  borderRadius: 3,
                  padding: 24,
                  display: "flex",
                  flexDirection: "column",
                  gap: 16,
                }}
              >
                <label
                  style={{
                    display: isMobile ? "flex" : "block",
                    gap: 8,
                    alignItems: "center",
                  }}
                >
                  I would like to donate with the following team
                  <span className="team-dropdown-span">(optional)</span>
                </label>
                <CustomSelect
                  clearable={true}
                  className="team-custom-select"
                  name="referrerID"
                  placeholder="Select a team"
                  onChange={onChange}
                  options={referrers.map((referrer) => ({
                    display: referrer.name,
                    value: referrer.id,
                  }))}
                  value={referrerID}
                />
              </div>
            )}
          </div>
          <div style={{ color: "rgba(0, 0, 0, 0.87)" }}>
            {currencyCode === currencyCodes.GBP && (
              <CustomCheckbox
                checked={isUkGiftAid}
                className="span-two mt-16"
                label="The prize draw can be entered for free, making it eligible for Gift Aid. Please confirm you are a U.K. citizen and would like to Gift Aid this donation."
                name="isUkGiftAid"
                onChange={onChangeEvent}
              />
            )}

            {currencyCode === currencyCodes.GBP ? (
              <div className="mt-24">
                <p
                  className="mb-16 line-height-double"
                  style={{ color: "rgba(0,0,0,.87)" }}
                >
                  I have read and understood and agree to be bound by the{" "}
                  <span
                    className="pointer underline-text"
                    onClick={(evt) =>
                      toggleShowTermsAndConditions(
                        evt,
                        termsAndConditions.legalText
                      )
                    }
                  >
                    Official Rules
                  </span>{" "}
                  of the Chabad on Campus {gregorianYear} Prize Draw and consent
                  to the use of the personal information I provide in my entry
                  form, which may reveal my racial or ethnic origin and/or
                  religious or philosophical beliefs, for the purposes of the
                  administration of the prize draw, which will include the
                  transfer of my personal information to the USA, by:
                </p>
                <CustomCheckbox
                  className="mb-16"
                  checked={didAcceptUKPromoterTerms}
                  error={submitAttempted && !didAcceptUKPromoterTerms}
                  label="The Promoter, Chabad Lubavitch (operating as Chabad on Campus)"
                  name="didAcceptUKPromoterTerms"
                  onChange={this.toggleAcceptTerms}
                />
                <CustomCheckbox
                  checked={didAcceptUKAdminTerms}
                  error={submitAttempted && !didAcceptUKAdminTerms}
                  label="The Prize Draw Administrator, PCG365, LLC"
                  name="didAcceptUKAdminTerms"
                  onChange={this.toggleAcceptTerms}
                />
              </div>
            ) : (
              <div className="custom-checkbox-container span-two flex mt-16">
                <CustomCheckbox
                  checked={didAcceptNonUKTerms}
                  error={submitAttempted && !didAcceptNonUKTerms}
                  label={
                    <span className="fs-16">
                      I agree to the {gregorianYear} Chabad on Campus Prize Draw{" "}
                      <span
                        className="pointer underline-text"
                        onClick={(evt) =>
                          toggleShowTermsAndConditions(
                            evt,
                            termsAndConditions.legalText
                          )
                        }
                      >
                        Official Rules
                      </span>
                      , Chabad on Campus International{" "}
                      <span
                        className="pointer underline-text"
                        onClick={(evt) =>
                          toggleShowTermsAndConditions(
                            evt,
                            termsAndConditions.privacyPolicy
                          )
                        }
                      >
                        Privacy Policy
                      </span>
                      , and the{" "}
                      <span
                        className="pointer underline-text"
                        onClick={(evt) =>
                          toggleShowTermsAndConditions(
                            evt,
                            termsAndConditions.cookiePolicy
                          )
                        }
                      >
                        Cookie Policy
                      </span>
                      .
                    </span>
                  }
                  name="didAcceptNonUKTerms"
                  onChange={this.toggleAcceptTerms}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
